/* This is the climate Change component N.7 */

<template>
  <v-container>
    <div>
      <strong>
        <span v-html="title"></span>
      </strong>
    </div>
    <div>
      <table
        style="height: 43px"
        width="800px;"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 350px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              បរិយាយ
            </td>
            <td class="row-data">ខ្វះអគ្គីសនី<br />(ភ្លើងឧស្សាហ៍ដាច់)</td>
            <td class="row-data">ខ្វះទឹកស្អាតប្រើប្រាស់</td>
            <td class="row-data">បង្គន់ប្រើប្រាស់អត់កើត</td>
          </tr>
          <tr v-for="(value, row) in ele_wat.length" :key="row">
            <td
              style="
                width: 350px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ ele_wat[row] }}
            </td>
            <td v-for="(value, col) in data.length" :key="col" class="row-data">
              <numberinput v-model="data[col]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { ele_wat } from "@/utils/ascf/climateVariables.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      ele_wat: ele_wat,
    };
  },
};
</script>
<style scoped>
.number {
  width: 150px;
  text-align: center;
}
.row-data {
  width: 150px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>